import React, { useEffect, useState } from 'react';
import { getBusinessAreaBySlug } from '../../api';
import './Maintenance.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const Maintenance = () => {
  const [businessAreas, setBusinessAreas] = useState(null);

  useEffect(() => {
    getBusinessAreaBySlug('maintenance')
      .then((response) => setBusinessAreas(response.data))
      .catch((error) => console.error('사업 영역을 가져오는 중 오류 발생:', error));
  }, []);

  if (!businessAreas || !businessAreas.area_name) {
    return <p>데이터를 불러오는 중입니다...</p>;
  }

  const { area_content, sections = [] } = businessAreas;
  const equipmentSection = sections.find((section) =>
    String(section.section_title).includes('투입장비')
  );
  const orderedSections = [
    ...sections.filter((section) => section !== equipmentSection),
    ...(equipmentSection ? [equipmentSection] : []),
  ];

  return (
    <div className="container py-5">
      <p
        className="monitoring-content text-center mb-5"
        dangerouslySetInnerHTML={{ __html: (area_content || '').replace(/\n/g, '<br/>') }}
      />
      <div className="row">
        {orderedSections.map((section, index) => {
          const isEquipment = section === equipmentSection;
          return (
            <div key={section.section_id || index} className="col-md-6 mb-4">
              <div className="maintenance-custom-card shadow-sm h-100">
                <div className="d-flex align-items-center maintenance-custom-header mb-3">
                  <div className="maintenance-section-id rounded-circle d-flex align-items-center justify-content-center mr-3">
                    {`0${index + 1}`}
                  </div>
                  <h4 className="maintenance-custom-title mb-0">{section.section_title}</h4>
                </div>
                <div className="maintenance-custom-body">
                  <ul className={`maintenance-list pl-3 ${isEquipment ? 'maintenance-horizontal-list' : ''}`}>
                    {(section.items || []).map((item, itemIndex) => (
                      <li
                        key={item.item_id || itemIndex}
                        className={`maintenance-item ${isEquipment ? 'maintenance-horizontal-item' : ''}`}
                      >
                        {isEquipment ? (
                          <>
                            <i className="fas fa-check-circle text-primary"></i>
                            <span className="maintenance-item-name">{item.item_content}</span>
                            <div className="maintenance-image-container">
                              <img
                                src={`/image_${itemIndex + 1}.jpg`}
                                alt={item.item_content}
                                className="maintenance-img-fluid"
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <i className="fas fa-check-circle mr-2 text-primary"></i>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: String(item.item_content).replace(/\n/g, '<br/>'),
                              }}
                            />
                          </>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Maintenance;
